import { APP_CONFIG_ENDPOINT } from "../config/urls";
import { fetcher } from "../helpers/fetcher";
import {
  IS_ADS_ENABLED,
  IS_JC_ENABLED,
  IS_ATOZ_ENABLED,
  HIDE_ATOZ_TASK,
} from "../config/appConfigConstants";
import { getJobScheduleDetails } from "./application-data";
import { save } from "./local-storage";

function handleCriticalConfigError(
  configName: string,
  configValue: string | null
) {
  //throw error when critical config is missing
  if (!configValue) {
    throw Error(`Missing critical config:${configName}.`);
  }
}
export interface CandidateData {
  candidateId: string;
  sfCandidateId: string;
}

export const getConfigurations = () => {
  if (process.env.NODE_ENV === "development") {
    if (process.env.REACT_APP_USE_MOCK_REQUESTS === "true") {
      console.warn("getConfigurations", "mocked request");
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            configurations: {
              configurationsArray: [
                {
                  configurationName: "isAdsEnabled",
                  defaultValue: true,
                },
                {
                  configurationName: "isJobContainerEnabled",
                  defaultValue: true,
                },
                {
                  configurationName: "isAtoZEnabled",
                  defaultValue: true,
                  siteFilters: [
                    "SITE-BUF5",
                    "SITE-BWI5",
                    "SITE-OKC5",
                    "SITE-KCPD",
                    "SITE-DXC5",
                    "SITE-MIA5",
                  ],
                },
              ],
            },
            isCached: true,
          });
        }, 1000);
      });
    }
  }

  return fetcher(APP_CONFIG_ENDPOINT);
};

export async function processConfigurations(
  appConfig: any,
  applicationId: string
) {
  if (
    !appConfig ||
    !appConfig.configurations ||
    !appConfig.configurations.configurationsArray
  ) {
    //no valid AppConfig or no valid format found for AppConfig
    return;
  }

  for (const config of appConfig.configurations.configurationsArray) {
    const configName = config.configurationName;
    if (!config.configurationName) {
      continue;
    }
    //saves into local storage
    if (configName == IS_ADS_ENABLED || configName == IS_JC_ENABLED) {
      //config schema should be validated when uploading to AppConfig. Throw exception in case critical config is malformed.
      handleCriticalConfigError(configName, config.defaultValue);
      localStorage.setItem(configName, config.defaultValue);
    }

    if (configName == IS_ATOZ_ENABLED) {
      let hideAtoZTask = true;
      if (config.defaultValue) {
        const scheduleDetails = await getJobScheduleDetails(applicationId);
        if (config.siteFilters.length == 0) {
          hideAtoZTask = false;
        } else if (scheduleDetails.siteId) {
          if (config.siteFilters.includes(scheduleDetails.siteId)) {
            hideAtoZTask = false;
          }
        }
      }

      save(HIDE_ATOZ_TASK + applicationId, hideAtoZTask);
    }
  }
}

export function isADSEnabled() {
  const configValue = localStorage.getItem(IS_ADS_ENABLED);
  // handleCriticalConfigError(IS_ADS_ENABLED, configValue);
  //turn on by default
  return configValue == "false" ? false : true;
}

export function isJobContainerEnabled() {
  const configValue = localStorage.getItem(IS_JC_ENABLED);
  // handleCriticalConfigError(IS_JC_ENABLED, configValue);
  return configValue == "false" ? false : true;
}
